import { Camera, Lightbulb, ShieldCheck, Layers, MessageCircle, MapPinned } from "lucide-react";

const ITEMS = [
  { num: "01", title: "Vermarktungs-DNA", desc: "Bilder, die wirklich verkaufen — aus Makler-Erfahrung entwickelt.", Icon: Camera },
  { num: "02", title: "Wirtschaftspsychologie", desc: "Visuelle Reize, die Vertrauen erzeugen und Kaufentscheidungen beeinflussen.", Icon: Lightbulb },
  { num: "03", title: "Realistisch & ehrlich", desc: "Keine Hochglanz-Lüge — Objekte authentisch ohne technische Fehler.", Icon: ShieldCheck },
  { num: "04", title: "Voller Content-Mix", desc: "Foto, Video, Drohne, 3D, Virtual Staging — alles aus einer Hand.", Icon: Layers },
  { num: "05", title: "Klare Kommunikation", desc: "Transparenter Ablauf, verlässliche Liefertermine, professionelle Betreuung.", Icon: MessageCircle },
  { num: "06", title: "NRW-Fokus", desc: "Aachen, Köln, Düren — mit lokalem Marktverständnis.", Icon: MapPinned },
];

export default function WhyUs() {
  return (
    <section data-testid="why-us-section" className="py-24 md:py-32 bg-[#F8F5EF]">
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-6 reveal">
            <div className="flex items-center gap-3 mb-6">
              
              <span className="overline">Warum Wertbild</span>
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl leading-[1.02] text-[#1A1A1A] tracking-tight">
              Mehr als <br />
              ein Fotograf. <br />
              Ein <span className="gold-text italic">Partner</span>.
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-12 gap-y-14">
          {ITEMS.map((it, idx) => (
            <div
              key={it.num}
              data-testid={`why-us-${it.num}`}
              className={`reveal ${idx % 3 === 1 ? "lg:mt-12" : ""}`}
            >
              <div className="flex items-center gap-5 mb-6">
                <span className="ticker-num text-3xl text-[#FFA500]">{it.num}</span>
                <span className="flex-1 h-px bg-[#EAE6DE]"></span>
                <it.Icon size={18} className="text-[#1A1A1A]" strokeWidth={1.5} />
              </div>
              <h3 className="font-display text-[26px] md:text-[28px] text-[#1A1A1A] tracking-tight">{it.title}</h3>
              <p className="mt-3 text-[14px] leading-relaxed text-[#5A5A5A] font-light">{it.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
